import '../../CommonStyles.scss';
import Chart from 'chart.js/auto';
import { CategoryScale } from 'chart.js';
import { useGetWebinarsSummary } from 'queryHooks/Admin/analytics';
import { Doughnut } from 'react-chartjs-2';
import Paper from '@trackman/web-shared-components/components/Paper/Paper';
import { getLatestDayData } from 'utilities/getLatestDayData';
import { options } from '../../consts/doughnutChartConfig';
import { SourceBadge } from '../SourceBadge/SourceBadge';
import { ChartHeader } from '../ChartHeader/ChartHeader';

Chart.register(CategoryScale);

export const ViewsDistributionChartCard = () => {
  return (
    <Paper className='analytics-card'>
      <ChartHeader title='Views distribution' badges={['YOUTUBE', 'VIMEO']} />
      <ViewsDistributionChart />
    </Paper>
  );
};

const ViewsDistributionChart = () => {
  const NUMBER_OF_ENTRIES = 10;

  const { data: webinarsSummary } = useGetWebinarsSummary();
  const latestDayData = getLatestDayData(webinarsSummary || [], 'date');
  const sortedWebinarsData = latestDayData?.sort((a, b) => b.views - a.views);

  const individualChartEntries = sortedWebinarsData?.slice(0, NUMBER_OF_ENTRIES);

  const chartEntriesToBeGrouped = sortedWebinarsData?.slice(NUMBER_OF_ENTRIES);
  const otherWebinarsViewsCount = chartEntriesToBeGrouped?.reduce((sum, entry) => sum + entry.views, 0) ?? 0;

  const chartEntries = [...individualChartEntries, { title: 'Other webinars', views: otherWebinarsViewsCount }];

  const COLORS = [
    '#ec691a', // brandOrange
    '#c7a755', // brand gold
    '#e03515', // vivid red-orange
    '#f5b830', // golden yellow
    '#a04010', // dark burnt sienna
    '#f8d870', // pale gold
    '#7a2008', // deep mahogany
    '#f09050', // light peach
    '#b58d00', // dark amber
    '#fce8b0', // pale cream
    '#8c8c8c', // neutral gray — Other webinars
  ];

  const labels = chartEntries?.map((entry) => entry.title) ?? [];
  const chartDataset = {
    labels,
    datasets: [
      {
        data: chartEntries?.map((entry) => entry.views) ?? [],
        backgroundColor: COLORS,
        barThickness: 17,
      },
    ],
  };

  return (
    <div style={{ height: '260px' }}>
      <Doughnut data={chartDataset} options={options} />
    </div>
  );
};
